module.exports = __webpack_public_path__ + "img/6-about.d75c9cd6.jpg";